<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddItem from "@/own/components/users/accounts/AddItem.vue";
import AddItemForClients from "@/own/components/users/accounts/AddItemForClients.vue";
import EditItem from "@/own/components/users/accounts/EditItem.vue";
import EditItemForClients from "@/own/components/users/accounts/EditItemForClients.vue";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/accounts.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "Accounts",
  components: { DataTable },
  data: () => ({
    delete_url: `/authorizations/accounts/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getACCOUNTSTableFilters",
      getTableState: "getACCOUNTSTableState",
      getTableData: "getACCOUNTSTableData",
      getTableHeaders: "getACCOUNTSTableHeaders",
      getTableProperties: "getACCOUNTSTableProperties",
      getTableExportUrl: "getACCOUNTSExportUrl",
      getTablePermissions: "getACCOUNTSTablePermissions",
    },
    urls: {
      delete: `/authorizations/accounts/destroy`,
      activate: `/authorizations/accounts/activate`,
      status: `/authorizations/accounts/status`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
    componentForAdding() {
      return this.$store.getters.isClient ? AddItemForClients : AddItem;
    },
    componentForEditing() {
      return this.$store.getters.isClient ? EditItemForClients : EditItem;
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
